export default __webpack_public_path__ + "static/media/cutIdentityCard.cf7694a4.svg";